<template>
  <section class="bg-gradient-to-b from-[#4796FF] to-[#2366BF] h-[200px] w-full relative top-[-72px] -z-50 flex justify-center">
  </section>
</template>

<script>
export default {
    components: {
        
    }
}
</script>Searchbar